function init_admin_monthly_income_widget(elm, filters) {
    const $ = jQuery.noConflict();

    const table = elm.find('table');
    table.reloadThisElement(function() {
        let total = 0;
        table.find('tbody').find('td:nth-child(2)').each(function() {
           const td = $(this);
           const revenue = parseInt(td.text().trim().substr(2).split(',')[0].split('.').join(''));
           total = total + revenue;
        });
        elm.find('.total-wrapper').html($.number(total, 0, ",", "."));
    });
}